module.exports = __webpack_public_path__ + "static/media/ico-man.542e94ba.svg";